import React, { createContext } from 'react'
import { useLicenseInformation } from './fetchHooks'
import { LicenseInformationRecordType } from './types'
import {
  createFetchContextProps,
  FetchContextType
} from '@signal/core/contextFetch'
import createContextFetchLoader from '@signal/core/contextFetch/Loader'

export function createLicenseInformationDataContext(): React.Context<
  FetchContextType<Array<LicenseInformationRecordType>>
> {
  return createContext(
    createFetchContextProps<Array<LicenseInformationRecordType>>()
  )
}

// this is the fetch context which can provide data obtained from the license information endpoints
export const LicenseInformationDataContext = createLicenseInformationDataContext()

export const LicenseInformationDataFetcher = createContextFetchLoader<
  Array<LicenseInformationRecordType>
>({
  fetchHook: useLicenseInformation,
  FetchContext: LicenseInformationDataContext
})
